<ng-container *transloco="let t">
	<ngb-datepicker
		[class.hideDateName]="hideName"
		#dp
		navigation="none"
		showWeekNumbers="true"
		[startDate]="startDate"
		[minDate]="minDate"
		[maxDate]="maxDate"
		[formControl]="control"
		[dayTemplate]="customDay"
		showWeekdays="false"></ngb-datepicker>

	<ng-template #customDay
				 let-date
				 let-currentMonth="currentMonth"
				 let-selected="selected"
				 let-disabled="disabled"
				 let-focused="focused">
		<div class="btn-light has-overlay"
			 *ngIf="calOverlay['year_'+date.year] && calOverlay['year_'+date.year]['month_'+date.month] && calOverlay['year_'+date.year]['month_'+date.month]['day_'+date.day]"
			 [class.active]="selected"
			 [class.notCurrent]="date.month != currentMonth"
			 [class.hidden]="date.month !== currentMonth"
			 [ngbTooltip]="calOverlay['year_'+date.year]['month_'+date.month]['day_'+date.day].entries.length + ' ' + t('entries')"
			 [class.text-muted]="disabled">
			{{ date.day }}
			<span *ngIf="calOverlay['year_'+date.year]['month_'+date.month]['day_'+date.day].entries.length"></span>
			<span *ngIf="calOverlay['year_'+date.year]['month_'+date.month]['day_'+date.day].entries.length > 1"></span>
			<span *ngIf="calOverlay['year_'+date.year]['month_'+date.month]['day_'+date.day].entries.length > 5"></span>
			<span *ngIf="calOverlay['year_'+date.year]['month_'+date.month]['day_'+date.day].entries.length > 10"></span>
			<span *ngIf="calOverlay['year_'+date.year]['month_'+date.month]['day_'+date.day].entries.length > 20"></span>
		</div>
		<div class="btn-light"
			 *ngIf="!calOverlay['year_'+date.year] || !calOverlay['year_'+date.year]['month_'+date.month] || !calOverlay['year_'+date.year]['month_'+date.month]['day_'+date.day]"
			 [class.active]="selected"
			 [class.notCurrent]="date.month != currentMonth"
			 [class.hidden]="date.month !== currentMonth"
			 [class.text-muted]="disabled">
			{{ date.day }}
		</div>
	</ng-template>

	<div class="extraPick c-ml-3 c-mr-1 d-flex justify-content-between">
		<div class="pick">
			<button class="btn btn-sm btn-light"
					(click)="next(false)"
					[ngbTooltip]="t('calendarWithOverlay.clickToPrevMonth')">
				<i class="fa fa-chevron-left"></i>
			</button>
			<select name="months"
					(change)="monthChange($event)"
					[ngbTooltip]="t('calendarWithOverlay.clickToChangeMonth')">
				<option [selected]="i === dp.model.focusDate.month - 1"
						[value]="i"
						*ngFor="let m of months; let i = index">{{ m | date: 'MMMM' }}</option>
			</select>
			<button class="btn btn-sm btn-light"
					(click)="next()"
					[ngbTooltip]="t('calendarWithOverlay.clickToNextMonth')">
				<i class="fa fa-chevron-right"></i></button>
		</div>

		<div class="pick">
			<button class="btn btn-sm btn-light"
					(click)="next(false, 'y')"
					[ngbTooltip]="t('calendarWithOverlay.clickToPrevYear')">
				<i class="fa fa-chevron-left"></i>
			</button>
			<select name="years"
					(change)="yearChange($event)"
					[ngbTooltip]="t('calendarWithOverlay.clickToChangeYear')">
				<option [selected]="y === dp.model.focusDate.year"
						[value]="y"
						*ngFor="let y of years">{{ y }}</option>
			</select>
			<button class="btn btn-sm btn-light"
					(click)="next(true, 'y')"
					[ngbTooltip]="t('calendarWithOverlay.clickToNextYear')">
				<i class="fa fa-chevron-right"></i></button>
		</div>
	</div>

</ng-container>
